import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Packages, Plans } from '@C/Admin/Packages/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      {/* <Route path="/packages/basic" component={Basics} />
      <Route path="/packages/standard" component={Standard} /> */}
      <Route path="/subscription/packages" component={Packages} />
      <Route path="/subscription/plans" component={Plans} />
      <Route path="/subscription/*">
        <Redirect to={`/subscription/packages`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
